var _rect, _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmoteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 17,
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5609,
    cy: 30.0765,
    r: 19.9091,
    stroke: "#303030",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9089,
    cy: 25.7505,
    r: 2.88401,
    fill: "#303030"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.7712,
    cy: 25.7505,
    r: 2.88401,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.097 35.1234H18.0249C18.0249 38.3679 21.6299 43.0544 29.561 43.0544C37.492 43.0544 41.097 38.7284 41.097 35.1234Z",
    stroke: "#303030",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoteActive);
export default __webpack_public_path__ + "static/media/emote-active.085eb4907f2c23b357a4903177219868.svg";
export { ForwardRef as ReactComponent };